export const THANKS = 'Thanks';
export const PREV = 'Prev';
export const NEXT = 'Next';
export const COMING_SOON = 'Coming soon';
export const SPONSORED = 'Sponsored';
export const EDIT = 'Edit';
export const SAVE = 'Save';
export const DELETE = 'Delete';
export const EXIT = 'Exit';
export const YOU_WANT_TO_EXIT = 'Are you sure you want to exit?';
export const YOU_ARE_ALL_SET = 'You’re all set!';
export const CONTINUE_EXPLORING = 'Continue Exploring';
export const START_THE_TOUR = 'Start the tour';
export const NO_THANKS = 'No, thanks';
export const SHARE = 'Share';
export const DOWNLOAD = 'Download';
export const GENERATING_PDF = 'Generating pdf';
export const SHOW_MORE = 'Show More';
export const SHOW_LESS = 'Show Less';
export const VIEW_ALL = 'View All';
export const CLEAR = 'Clear';
export const SEARCH = 'Search';
export const DATE = 'Date';
export const ARCHIVE = 'Archive';
export const UNARCHIVE = 'Unarchive';
export const CANCEL = 'Cancel';
export const CONTACT_MANTA_TEAM = 'Contact Manta Team';
export const START_DATE = 'Start date';
export const END_DATE = 'End date';
export const SESSION_ABOUT_TO_EXPIRE = 'Your session is about to expire.';
export const STAY_LOGGED_IN = 'Stay Logged In';
export const LOGOUT_NOW = 'Logout Now';
export const SUBMIT = 'Submit';
export const NO_MATCH_FOUND_TITLE = 'We couldn’t find any matches :(';
export const NO_MATCH_FOUND_SUBTITLE = 'Try changing the filters';
export const PARTNER = 'Partner';
export const ARCHIVE_TOAST_CONTENT = 'has been archived successfully.';
export const UNARCHIVE_TOAST_CONTENT = 'has been unarchived successfully.';
export const CONFIRM = 'Confirm';
export const REGION = 'Region';
